/* BLOG SECTION  */
export default function Style(){
  return(
    <style>
      {
        `
        .blog_section {
 
          background-size: auto, cover !important;
          background-repeat: no-repeat !important;
          background-blend-mode: normal !important;
          background-position: center center !important;
           background-attachment: fixed !important;
          
        }
        
        .blog_link {
          color: #fff;
          cursor: pointer;
        }
        
        .blog_link:hover {
          color: #ffd492;
        }
        
        
        
        
        /* BLOGER SLIDER SECTION  */
        
        
        .blog3 {
        
          height: 140px;
          background-blend-mode: normal;
          background-repeat: no-repeat;
          background-size: auto,
            cover;
        
        }        
        
        `
      }
    </style>
  )
}
